var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "form" },
    [
      _c(
        "b-container",
        [
          _c("div", { attrs: { id: "v-step-0" } }, [
            _vm._v(
              "A DOM element on your page. The first step will pop on this element because its ID is 'v-step-0'."
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "v-step-1" }, [
            _vm._v(
              "A DOM element on your page. The second step will pop on this element because its ID is 'v-step-1'."
            ),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { "data-v-step": "2" } }, [
            _vm._v(
              "A DOM element on your page. The third and final step will pop on this element because its ID is 'v-step-2'."
            ),
          ]),
          _vm._v(" "),
          _c("v-tour", { attrs: { name: "myTour", steps: _vm.steps } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("VueTour"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }